import React, { useState, useEffect, useRef } from "react";
import "../../../src/styles/UploadForm.css";
// import { toast } from "react-toastify";
import { Tooltip } from '@appkit4/react-components/tooltip';
import displayToastMessage from "../../../src/components/Common/Alert/displayToastMessage";

// export interface IPropType {
//   onUpload: () => {};
//   isMultiple: boolean;
//   onDeleteAll: () => {};
//   title: string;
//   existingFiles: [];
//   accept:String;
//   tooltipTitle: Optional[string]
// }

export default function UploadForm(props) {
  const {
    onUpload,
    isMultiple = false,
    onDeleteAll,
    title = "Upload file",
    existingFiles,
    accept=".JPG,.PNG,.PDF,.DOC,.DOCX,.xls,.xlsx,.pdf,.txt,.csv,.png,.jpeg,.jpg,.ppt,.pptx",
    tooltipTitle = "Upload file"

  } = props;
  const [files, setFiles] = useState(existingFiles ?? []);

  const fileInput = useRef(null);

  const handleUpload = (data) => {
    const fileNotInSizeLimit = Array.from(data).filter(
      (file) => Math.ceil(file.size / 1000) > 5000
    ).length > 0;
    if (fileNotInSizeLimit) {
      displayToastMessage("File size exceeds the limit of 5MB", "error");

    } else {
      const filterExisting = Array.from(data).filter((item) =>
        files.length > 0
          ? !files?.find((file) => file.name === item.name)
          : item
      );
      const filesToSet = isMultiple ? [...files, ...filterExisting] : [...data];
      setFiles(filesToSet);
      onUpload(filesToSet);
    }
  };

  const handleDeleteAll = () => {
    setFiles([]);
    onDeleteAll();
  };

  const handleDelete = (name) => {
    setFiles(files.filter((item) => item.name !== name));
    onDeleteAll(name);
  };

  const truncate = (str) => {
    return str.length > 35 ? str.substring(0, 35) + "..." : str;
  };

  useEffect(() => {
    if (existingFiles) {
      setFiles(existingFiles);
    }
  }, [existingFiles]);

  return (
    <div>
      <div className="file-title">
      <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        appendAfterTarget={true}
        content={tooltipTitle}
      >
        <span>{truncate(title)}</span>
        </Tooltip>
      </div>
      {isMultiple && (
        <div className="file-subtitle">
          <span>Multiple documents can be added here</span>
        </div>
      )}
      <div
        className="dashed-container"
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          handleUpload(e.dataTransfer.files);
          e.target.value = "";
        }}
      >
        <button
          className="upload-button"
          onClick={() => fileInput.current.click()}
          type="button"
        >
          <span className="upload-text">
            <span>Drag and drop or </span>
            <span className="text-underline">choose file</span>
            <input
              type="file"
              multiple={isMultiple ? "multiple" : null}
              onChange={({ target }) => {
                handleUpload(target.files);
                target.value = "";
              }}
              accept={accept}
              ref={fileInput}
              tabIndex="-1"
              hidden
            />
          </span>
        </button>
      </div>
      {files &&
        files[0]?.name &&
        files?.map((file, index) => (
          <div className="files-list" key={index}>
            <span aria-hidden="true">
              <span className="Appkit4-icon icon-document-text-outline"></span>
            </span>
            <span className="file-upload">
              <span className="file-name">{file.name} </span>
              <span className="file=size">
                ({Math.ceil(file.size / 1000)}kb)
              </span>
            </span>
            <span className="ap-fileupload-success">
              <span className="Appkit4-icon icon-circle-checkmark-outline"></span>
            </span>
            {isMultiple && (
              <span
                className="Appkit4-icon icon-delete-fill icon-color ap-font-15"
                onClick={(e) => {
                  e.preventDefault()
                  handleDelete(file.name)}}
                title="delete"
              />
            )}
          </div>
        ))}
      {files.length > 0 && files[0]?.name && (
        <div className="file-delete">
          <span role="button" onClick={() => handleDeleteAll()}>
            Delete {isMultiple ? "all attachments" : "attachment"}
          </span>
        </div>
      )}
    </div>
  );
}
